import { lazy } from 'react';

export const GmoAddRequestPage = lazy(() => import('./AddRequest/AddRequest'));
export const GmoRequestsEditPage = lazy(() => import('./EditPage/EditPage'));
export const GmoRegistryEditPage = lazy(() => import('./EditPage/EditPage'));
export const GmoInactiveEditPage = lazy(() => import('./EditPage/EditPage'));
export const GmoRequestsViewPage = lazy(() => import('./ViewPage/ViewPage'));
export const GmoRegistryViewPage = lazy(() => import('./ViewPage/ViewPage'));
export const GmoInactiveViewPage = lazy(() => import('./ViewPage/ViewPage'));
